import { FilterAutocomplete } from '../baseInputTypes/FilterAutocomplete'

type Props = {}
export const Duties = (props: Props) => (
  <FilterAutocomplete
    label="Duties"
    fieldName={'duties'}
    fieldPath={'productInformation.duties'}
  />
)
